/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Workspace API
 * Workspace builder APIs for FormOps
 * OpenAPI spec version: 1.0
 */

export type ExchangeTicketDataResponsePurpose = typeof ExchangeTicketDataResponsePurpose[keyof typeof ExchangeTicketDataResponsePurpose];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExchangeTicketDataResponsePurpose = {
  SIGNUP: 'SIGNUP',
  LOGIN: 'LOGIN',
  LINK_ACCOUNT: 'LINK_ACCOUNT',
  ACCEPT_INVITATION: 'ACCEPT_INVITATION',
  CONNECT_INTEGRATION: 'CONNECT_INTEGRATION',
  MY_FORMS: 'MY_FORMS',
} as const;
